import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

const People = (props) => {
    const { people, onChangeMaskVisible, onChangeCurrentVideo, guestData, index } = props;

    const openVideo = (type) => {
        if (type === 'prev') {
            onChangeCurrentVideo({
                url: people.video_1,
                duration: people.video_1_duration,
                guid: people.video_1_guid,
            });
        }
        if (type === 'next') {
            onChangeCurrentVideo({
                url: people.video_2,
                duration: people.video_2_duration,
                guid: people.video_2_guid,
            });
        }

        if (type === 'story') {
            const storyData = guestData.filter((item) => item?.userName === people?.name);

            onChangeCurrentVideo({
                url: storyData?.[0]?.videoUrl || '',
                duration: storyData?.[0]?.videoDuration || '',
                guid: storyData?.[0]?.videoGuid || '',
            });
        }
        onChangeMaskVisible(true);
    };

    const guestDataFilter = guestData.filter((item) => item?.userName === people.name);

    return (
        <div className={Style.peopleDetail}>
            <img className={Style.bc} src={formatImageWebpAuto(people.largeImage, 2560, 914)} />
            <div className={`${Style.text} ${people.position === 'right' ? Style.right : ''}`}>
                <div className={Style.peopleInfo}>
                    <div className={Style.name}>{people.name}</div>
                    <div className={Style.desc}>{people.desc}</div>
                    <a className={Style.say} href={people.sayLink} target="_blank">
                        {people.say}
                    </a>
                </div>
                <div className={Style.videos}>
                    <div className={Style.video}>
                        {people?.video_1 && people?.video_2 && (
                            <div onClick={() => openVideo('prev')}>
                                <img src={require('@src/common/assets/play.png')} alt="" />
                                <span>上集</span>
                            </div>
                        )}
                        {people?.video_1 && !people?.video_2 && (
                            <div onClick={() => openVideo('prev')}>
                                <img src={require('@src/common/assets/play.png')} alt="" />
                                <span>正片</span>
                            </div>
                        )}
                    </div>

                    <div className={Style.video}>
                        {people?.video_2 && (
                            <div onClick={() => openVideo('next')}>
                                <img src={require('@src/common/assets/play.png')} alt="" />
                                <span>下集</span>
                            </div>
                        )}
                    </div>
                </div>
                {guestDataFilter?.[0]?.videoUrl && (
                    <div className={Style.extraStoryBox}>
                        <div className={Style.extraStory} onClick={() => openVideo('story')}>
                            <img src={require('@src/common/assets/play.png')} alt="" />
                            <span>番外篇</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

People.propTypes = {
    people: PropTypes.object,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    guestData: PropTypes.array,
    index: PropTypes.number,
};

export default errorBoundary(People);
